import './vendor';
import Swiper from '../../node_modules/swiper/js/swiper.js';
import inputmask from 'inputmask/dist/jquery.inputmask';
import {fancybox} from '@fancyapps/fancybox';
import tippy from 'tippy.js';
import select2 from 'select2';
import WOW from 'wow.js';
import 'jquery-validation';
import '../../node_modules/jquery-validation/dist/additional-methods.js';
import vars from './helpers';
import './components/header';
import './components/modal/feedback';
// import './components/mission';
import './components/tenders';
import './components/vacancies';
import 'sticky-kit/dist/sticky-kit';
import axios from "axios";
import osme from 'osme';

const $document = $(document);

const $window = $(window);

const $html = $('html');

const $body = $('body');

if ($html.attr('lang') == 'ru') {
    jQuery.extend(jQuery.validator.messages, {
        required: "Это поле необходимо заполнить.",
        remote: "Пожалуйста, введите правильное значение.",
        email: "Пожалуйста, введите корректный адрес электронной почты.",
        url: "Пожалуйста, введите корректный URL.",
        date: "Пожалуйста, введите корректную дату.",
        dateISO: "Пожалуйста, введите корректную дату в формате ISO.",
        number: "Пожалуйста, введите число.",
        digits: "Пожалуйста, вводите только цифры.",
        creditcard: "Пожалуйста, введите правильный номер кредитной карты.",
        equalTo: "Пожалуйста, введите такое же значение ещё раз.",
        extension: "Пожалуйста, выберите файл с правильным расширением.",
        maxlength: $.validator.format("Пожалуйста, введите не больше {0} символов."),
        minlength: $.validator.format("Пожалуйста, введите не меньше {0} символов."),
        rangelength: $.validator.format("Пожалуйста, введите значение длиной от {0} до {1} символов."),
        range: $.validator.format("Пожалуйста, введите число от {0} до {1}."),
        max: $.validator.format("Пожалуйста, введите число, меньшее или равное {0}."),
        min: $.validator.format("Пожалуйста, введите число, большее или равное {0}."),
        accept: $.validator.format("Пожалуйста, выберите верный формат файла.")
    });
}

window.getUrlParams = function (sParam) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    for (let i = 0; i < sURLVariables.length; i++) {
        const sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1];
        }
    }
    return '';
}

$('.js-projects-filter-reset').on('click', function () {
    let href = '/projects/';
    if ($html.attr('lang') == 'ru') {
        href = '/ru' + href;
    }
    $(location).attr('href', href);
})

$.validator.addMethod(
    "regex",
    function (value, element, regexp) {
        if (regexp && regexp.constructor != RegExp) {
            regexp = new RegExp(regexp[0], regexp[1]);
        } else if (regexp.global) regexp.lastIndex = 0;
        return this.optional(element) || regexp.test(value);
    },
    $html.attr('lang') == 'ru' ? "Неверный формат" : "Invalid format",
);

$.validator.addMethod('filessize', function (value, element, param) {
    let sum = 0;

    for (let index = 0; index < element.files.length; index++) {
        sum += element.files[index].size;
    }
    return this.optional(element) || (sum <= param * 1000000)
}, $html.attr('lang') == 'ru' ? "Объем файлов не может превышать {0}Mb" : 'Files cannot exceed {0}Mb');

$.validator.addMethod('filescount', function (value, element, param) {
    return this.optional(element) || (element.files.length <= param)
}, $html.attr('lang') == 'ru' ? "Количество файлов не должно превышать {0} шт" : 'The number of files should not exceed {0} pieces');

let app = {
    global: {
        init() {
            $('.js-add-tender-to-form').on('click', function () {
                let $form = $('.js-tender-page-form');
                if ($form.length) {
                    let hidden_tender_elem = $form.find('.js-hidden-tender-input');
                    if (hidden_tender_elem.length) {
                        hidden_tender_elem.remove();
                    }
                    let tender_data = $(this).data('tender-id');
                    if (tender_data) {
                        $form.append(`<input type="hidden" class="js-hidden-tender-input" name="tender_id" value="${tender_data}"/>`);
                    }
                }
            });

            $('.js-add-vac-to-form').on('click', function () {
                let $form = $('.js-vac-page-form');
                {
                    if ($form.length) {
                        let hidden_vac_elem = $form.find('.js-hidden-vac-input');
                        if (hidden_vac_elem.length) {
                            hidden_vac_elem.remove();
                        }
                        let vac_name = $(this).closest('.vacancies__job').find('.js-vacancy-span').text();
                        if (vac_name) {
                            $form.append(`<input type="hidden" class="js-hidden-vac-input" name="vacancy" value="${vac_name}"/>`);
                        }
                    }
                }
            });

            $('.js-goto').on('click', (e) => {
                let $target = $($(e.currentTarget).data('target') || $(e.currentTarget).attr('href'));

                if ($target.length) {
                    e.preventDefault();
                    $('html, body').animate({
                        scrollTop: $target.offset().top - 120,
                    }, 400);
                }
            });

            $('[data-fancybox]').fancybox({
                touch: false,
                autoFocus: false,
                backFocus: false,
            });

            $document.on('click', '.js-toggle-class', (e) => {
                e.preventDefault();

                let options = $(e.currentTarget).data();

                switch (options.type) {
                    case 'add':
                        $html.addClass(options.class);
                        break;
                    case 'remove':
                        $html.removeClass(options.class);
                        break;
                    case 'toggle':
                        $html.toggleClass(options.class);
                        break;
                    default:
                        $html.toggleClass(options.class);
                        break;
                }
            });

            $('.js-show-hide').on('click', (e) => {
                let $this = $(e.currentTarget);

                let $target = $($this.data('target'));

                e.preventDefault();
                if ($target.length) {
                    $this.toggleClass('is-active');
                    if ($this.hasClass('is-active')) {
                        $target.stop().slideDown(500);
                        $this.find('span').text($this.data('on'));
                    } else {
                        $target.stop().slideUp(500);
                        $this.find('span').text($this.data('off'));
                    }
                }
            });

            $('.js-print').on('click', (e) => {
                e.preventDefault();
                window.print();
            });

            if (!vars.isMobile()) {
                $(".mission__nav").stick_in_parent({
                    offset_top: 100,
                });
            }

            new WOW().init();
            const subscribeAction = window.getUrlParams('ACTION');
            const subscribeId = window.getUrlParams('ID');
            const subscribeConfirmCode = window.getUrlParams('CONFIRM_CODE');
            const subscribeRubricId = window.getUrlParams('RUBRIC');
            const subscribeSiteId = window.getUrlParams('SITE_ID');
            if (parseInt(subscribeId, 10) > 0 && subscribeAction === 'unsubscribe' && subscribeConfirmCode && parseInt(subscribeRubricId, 10) > 0 && subscribeSiteId) {
                axios.get(
                    '/local/php_interface/api/',
                    {
                        params: {
                            method: 2,
                            ID: subscribeId,
                            CONFIRM_CODE: subscribeConfirmCode,
                            ACTION: subscribeAction,
                            RUBRIC: subscribeRubricId,
                            SITE_ID: subscribeSiteId,
                        }
                    }
                ).then((resp) => {
                    if (resp.data.message && resp.data.title) {
                        $.fancybox.open(`<div class="feedback feedback--success">
									<div class="h3 feedback__title">${resp.data.title}</div>
									<div class="feedback__text">${resp.data.message}</div>
								</div>`, {
                            touch: false,
                            autoFocus: false,
                        });
                    }
                });
            }
        },
    },
    header: {
        init($header) {
            $window.on('scroll', (e) => {
                if ($window.scrollTop() > 150) {
                    $header.addClass('is-fixed');
                } else {
                    $header.removeClass('is-fixed');
                }
            });

            $header.find('.js-change-item').on('click', (e) => {
                e.preventDefault();
                $header.find('.header__mobile__item').removeClass('is-active');
                $header.find(`.header__mobile__item[data-item="${$(e.currentTarget).data('target')}"]`).addClass('is-active');
            });

            $header.find('.header__mobile__arrow').on('click', (e) => {
                const $this = $(e.currentTarget);

                e.preventDefault();
                $this.toggleClass('is-active');
                if ($this.hasClass('is-active')) {
                    $this.closest('li').find('>ul').slideDown(400);
                } else {
                    $this.closest('li').find('>ul').slideUp(400);
                }
            });
        },
    },
    headerSearch: {
        init($form) {
            const $input = $form.find('.header__search__field input');

            const $result = $form.find('.header__search__result');

            let timeout;
            $form.addClass('is-show-result');
            $document.on('click', (e) => {
                let $target = $(e.target);
                
                if (!$target.closest('.header__link--search').length && !$target.closest('.header-in__link--search').length && !$target.closest('.header__search').length && !$target.closest('.header__search-btn').length) {
                    $html.removeClass('is-show-search');
                }
            });

            $input.on('keyup', () => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if ($input.val().trim().length > 2) {
                        $.ajax({
                            type: $form.attr('method'),
                            url: $form.data('action'),
                            data: $form.serialize() + '&is_ajax_search=Y',
                            success(response) {
                                let parsed_response = JSON.parse(response);
                                $('.js-search-body').empty();
                                if ((parsed_response.resultBody)) {
                                    $('.js-search-body').append($(parsed_response.resultBody));
                                }
                            },
                        });
                    }
                }, 500);
            });
        },
    },
    tabs: {
        init($tabs) {
            $tabs.find('> .tabs__nav > .tabs__nav__button').on('click', (e) => {
                let $target = $(e.currentTarget);
                let attr = $target.attr('data-tab');

                $tabs.find('> .tabs__nav > .tabs__nav__button').removeClass('is-active');
                $target.addClass('is-active');

                $tabs.find('> .tabs__container > .tabs__tab').addClass('is-hidden');
                $tabs.find('> .tabs__container > .tabs__tab').filter(`[data-tab="${attr}"]`).removeClass('is-hidden');
            });
        },
    },
    news: {
        init($news) {
            let slider = new Swiper($news.find('.swiper-container'), {
                // loop: true,
                slidesPerView: 1,
                spaceBetween: 24,
                navigation: {
                    prevEl: $news.find('.b-news__arrows__prev'),
                    nextEl: $news.find('.b-news__arrows__next'),
                },
                breakpoints: {
                    1025: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    }
                }
            });
        },
    },
    news3: {
        init($news) {
            let slider = new Swiper($news.find('.swiper-container'), {
                // loop: true,
                slidesPerView: 1,
                spaceBetween: 24,
                navigation: {
                    prevEl: $news.find('.b-news__arrows__prev'),
                    nextEl: $news.find('.b-news__arrows__next'),
                },
                breakpoints: {
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    }
                }
            });
        },
    },
    otherProducts: {
        init($container) {
            let slider = new Swiper($container.find('.swiper-container'), {
                // loop: true,
                slidesPerView: 1,
                navigation: {
                    prevEl: $container.find('.tenders__prev'),
                    nextEl: $container.find('.tenders__next'),
                },
                breakpoints: {
                    1025: {
                        slidesPerView: 3,
                    }
                }
            });
        },
    },
    accordion: {
        init($accordion) {
            let stickyInterval;
            $accordion.find('.accordion__item__head').on('click', (e) => {
                let $this = $(e.currentTarget);

                let $item = $this.closest('.accordion__item');

                let $content = $item.find('.accordion__item__content');

                e.preventDefault();
                $item.toggleClass('is-active');
                stickyInterval = setInterval(() => {
                    $('.mission__nav').trigger("sticky_kit:recalc");
                }, 15);
                if ($item.hasClass('is-active')) {
                    $content.stop().slideDown(250, () => {
                        clearInterval(stickyInterval);
                    });
                } else {
                    $content.stop().slideUp(250, () => {
                        clearInterval(stickyInterval);
                    });
                }
            });
        },
    },
    select: {
        init($select) {
            $select.find('select').select2({
                minimumResultsForSearch: $select.data('search') ? 5 : Infinity,
                dropdownParent: $select.find('.input__field'),
            });
            $('.js-news-filter-reset').on('click', function (e) {
                e.preventDefault();
                let filter_array = new Map();
                let type_filter = window.getUrlParams('type');
                if (type_filter) {
                    filter_array.set('type', type_filter);
                }
                let result_str = $('.js-news-page-type').val();
                if ($html.attr('lang') == 'ru') {
                    result_str = '/ru' + result_str;
                }
                let params_str = '';
                let counter = 0;
                filter_array.forEach(function (value, key) {
                    if (counter == 0) {
                        params_str += '?' + key + '=' + value;
                    } else {
                        params_str += '&' + key + '=' + value;
                    }
                    counter++;
                });
                axios.get(
                    result_str + params_str,
                    {
                        params: {
                            IS_NEWS_AJAX: 'Y',
                        }
                    }
                ).then((resp) => {
                    window.history.replaceState(
                        {},
                        document.title, result_str + params_str,
                    );
                    let $current_page_body = $('.js-news-items-body');
                    let $current_page_navi = $('.js-news-items-pagination');
                    let $ajax_page_body = $(resp.data.itemsBody);
                    let $ajax_page_navi = $(resp.data.navBody);
                    $current_page_body.html($ajax_page_body.html());
                    $current_page_navi.html($ajax_page_navi.html());
                    $('.js-news-filter').val('').trigger('change');
                });
            });
            $select.find('select.js-news-filter').on('select2:select', function () {
                const select_data = $(this).select2('data');
                const selected_value = select_data[0].id;
                let selected_option = select_data[0].element;
                let type_filter = window.getUrlParams('type');
                let year_filter = window.getUrlParams('year');
                let month_filter = window.getUrlParams('month');
                let filter_array = new Map();
                if (type_filter) {
                    filter_array.set('type', type_filter);
                }
                if (year_filter) {
                    filter_array.set('year', year_filter);
                }
                if (month_filter) {
                    filter_array.set('month', month_filter);
                }
                const filtered_attr_name = $(selected_option).attr('name');
                if (selected_value != '0') {
                    filter_array.set(filtered_attr_name, selected_value);
                } else {
                    filter_array.delete(filtered_attr_name);
                }
                let result_str = $('.js-news-page-type').val();
                if ($html.attr('lang') == 'ru') {
                    result_str = '/ru' + result_str;
                }
                let params_str = '';
                let counter = 0;
                filter_array.forEach(function (value, key) {
                    if (counter == 0) {
                        params_str += '?' + key + '=' + value;
                    } else {
                        params_str += '&' + key + '=' + value;
                    }
                    counter++;
                });
                axios.get(
                    result_str + params_str,
                    {
                        params: {
                            IS_NEWS_AJAX: 'Y',
                        }
                    }
                ).then((resp) => {
                    window.history.replaceState(
                        {},
                        document.title, result_str + params_str
                    );
                    let $current_page_body = $('.js-news-items-body');
                    let $current_page_navi = $('.js-news-items-pagination');
                    let $ajax_page_body = $(resp.data.itemsBody);
                    let $ajax_page_navi = $(resp.data.navBody);
                    $current_page_body.html($ajax_page_body.html());
                    $current_page_navi.html($ajax_page_navi.html());
                });
            });
            $select.find('select.js-projects-filter').on('select2:select', function () {
                const select_data = $(this).select2('data');
                const selected_value = select_data[0].id;
                let selected_option = select_data[0].element;
                let country_filter = window.getUrlParams('country');
                let course_filter = window.getUrlParams('course');
                let year_filter = window.getUrlParams('year');
                let filter_array = new Map();
                if (country_filter) {
                    filter_array.set('country', country_filter);
                }
                if (course_filter) {
                    filter_array.set('course', course_filter);
                }
                if (year_filter) {
                    filter_array.set('year', year_filter);
                }
                const filtered_attr_name = $(selected_option).attr('name');
                if (selected_value != '0') {
                    filter_array.set(filtered_attr_name, selected_value);
                } else {
                    filter_array.delete(filtered_attr_name);
                }
                let result_str = '/projects/';
                if ($html.attr('lang') == 'ru') {
                    result_str = '/ru' + result_str;
                }
                let params_str = '';
                let counter = 0;
                filter_array.forEach(function (value, key) {
                    if (counter == 0) {
                        params_str += '?' + key + '=' + value;
                    } else {
                        params_str += '&' + key + '=' + value;
                    }
                    counter++;
                });
                console.log(result_str);
                axios.get(
                    result_str + params_str,
                    {
                        params: {
                            IS_PROJECTS_AJAX: 'Y',
                        }
                    }
                ).then((resp) => {
                    window.history.replaceState(
                        {},
                        document.title, result_str + params_str
                    );
                    let $current_page_body = $('.js-projects-items-body');
                    let $current_page_navi = $('.js-projects-items-pagination');
                    let $ajax_page_body = $(resp.data.itemsBody);
                    let $ajax_page_navi = $(resp.data.navBody);
                    $current_page_body.html($ajax_page_body.html());
                    $current_page_navi.html($ajax_page_navi.html());
                });
            });
            $select.find('select').on('change', () => {
                try {
                    $select.find('select').valid()
                } catch {
                }
            });
        },
    },
    file: {
        init($file) {
            let $label = $file.find('.input__file__field__text');

            $file.on('change', 'input[type="file"]', (e) => {
                if (e.target.files.length === 0) {
                    $label.text($label.data('text'));
                    $file.removeClass('is-file-selected');
                } else if (e.target.files.length === 1) {
                    $label.text(e.target.files[0].name);
                    $file.addClass('is-file-selected');
                } else {
                    $label.text(`${$label.data('multiple') || 'Files count:'} ${e.target.files.length}`);
                    $file.addClass('is-file-selected');
                }
                $(e.currentTarget).valid();
            });

            $file.find('.input__file__remove').on('click', (e) => {
                e.preventDefault();
                $file.find('input[type="file"]').val('').trigger('change');
            });
        },
    },
    form: {
        init($form) {
            let validator = $form.validate({
                rules: {},
                submitHandler(form) {
                    if ($form.data('type') === 'submit') {
                        form.submit();
                    } else {
                        let preparedData;

                        let processData;

                        let contentType;

                        $form.removeClass('is-sended is-error');

                        if ($form.find('input[type="file"]').length > 0) {
                            preparedData = new FormData($form.get()[0]);
                            processData = false;
                            contentType = false;
                        }
                        grecaptcha.ready(function () {
                            grecaptcha.execute('6Lcn_kcaAAAAAK-JTj-HoyRPjPP9J0Zjtmo-tzjN', {action: 'submit'}).then(function (token) {
                                var form_serialize = $form.serialize();
                                form_serialize += '&token=' + token;
                                if (typeof preparedData !== 'undefined') {
                                    preparedData.append('token', token);
                                }
                                $.ajax({
                                    type: $form.attr('method'),
                                    url: $form.attr('action'),
                                    data: preparedData ? preparedData : form_serialize,
                                    dataType: 'json',
                                    processData: processData,
                                    contentType: contentType,
                                    success(result) {
                                        if (result.result === true) {
                                            $form[0].reset();
                                            $.fancybox.close();
                                        }
                                        $.fancybox.open(`<div class="feedback feedback--success">
									<div class="h3 feedback__title">${result.title}</div>
									<div class="feedback__text">${result.message}</div>
								</div>`, {
                                            touch: false,
                                            autoFocus: false,
                                        });
                                    },
                                });
                            });
                        });
                    }
                },
            });
            setTimeout(() => {
                $form.find('[data-validation]').each((index, item) => {
                    $(item).rules('add', $(item).data('validation'));
                });
            }, 1000);
        },
    },
    mask: {
        init($mask) {
            $mask.inputmask($mask.data('mask').toString(), {
                showMaskOnHover: false,
                clearIncomplete: true,
            });
        },
    },
    cookie: {
        init($cookie) {
            if (localStorage.cookiesAgree !== 'yes') {
                setTimeout(() => {
                    $cookie.fadeIn(250);
                }, 2000);
            }
            $cookie.find('.cookies__btn button').on('click', (e) => {
                e.preventDefault();
                localStorage.cookiesAgree = 'yes';
                $cookie.fadeOut(250);
            });
        },
    },
    descriptions: {
        init($descriptions) {
            let $logo = $descriptions.find('.descriptions__logo');

            $window.on('scroll.description', () => {
                if ($window.scrollTop() + $window.outerHeight() / 2 > $descriptions.offset().top) {
                    $descriptions.addClass('is-animated');
                    $window.off('scroll.description');
                }
            });

            $descriptions.find('.descriptions__subtext__more').on('click', (e) => {
                let $this = $(e.currentTarget);

                e.preventDefault();
                $this.toggleClass('is-active');
                if ($this.hasClass('is-active')) {
                    $descriptions.find('.descriptions__subtext__hidden').removeClass('is-hidden');
                    $this.text($this.data('on'));
                } else {
                    $descriptions.find('.descriptions__subtext__hidden').addClass('is-hidden');
                    $this.text($this.data('off'));
                }
            });
        },
    },
    states: {
        init($states) {
            let $map = $states.find('.states__map');

            let init = () => {
                let $navItems = $states.find('.states__nav__item');
                let $navCurrent = $states.find('.states__nav__current');
                let $mapItems = $states.find('.states__map__item');
                let $mapCircle = $states.find('.states__map__circle');
                let $republics = $states.find('.states__republic');

                $navItems.on('click', (e) => {
                    let $this = $(e.currentTarget);
                    let $targetMapItem = $mapItems.filter(`[data-item="${$this.data('item')}"]`);
                    let $targetMapItemCircle = $targetMapItem.find('.states__map__item__circle');

                    e.preventDefault();
                    $navItems.removeClass('is-active');
                    $mapItems.removeClass('is-active');
                    $republics.removeClass('is-active');
                    $this.addClass('is-active');
                    $targetMapItem.addClass('is-active');
                    $navCurrent.text($this.text());
                    $republics.filter(`[data-item="${$this.data('item')}"]`).addClass('is-active');
                    if ($mapCircle.length) {
                        $mapCircle.css({
                            top: $targetMapItemCircle.offset().top - $states.offset().top,
                            left: $targetMapItemCircle.offset().left - $states.offset().left,
                        });
                    }
                    $mapCircle.removeClass('is-animate');
                    $html.removeClass('is-states-show-list');
                    $navItems.each((index, item) => {
                        $states.removeClass($(item).data('item'));
                    });
                    $states.addClass($this.data('item'));
                    setTimeout(() => {
                        $mapCircle.addClass('is-animate');
                    }, 10);
                });

                $navCurrent.on('click', (e) => {
                    e.preventDefault();
                    $html.toggleClass('is-states-show-list');
                });

                $mapItems.on('click', (e) => {
                    e.preventDefault();
                    $navItems.filter(`[data-item="${$(e.currentTarget).data('item')}"]`).trigger('click');
                });

                $mapItems.eq(0).trigger('click');
            }

            $window.on('scroll.states', () => {
                if ($window.scrollTop() + $window.outerHeight() >= $states.offset().top) {
                    $window.off('scroll.states');

                    if ($map.data('ajax')) {
                        $.ajax({
                            type: 'get',
                            url: $map.data('ajax'),
                            data: {
                                mobile: $window.outerWidth() < 1025,
                            },
                            success(response) {
                                $map.html(response);
                                init();
                            },
                        });
                    } else {
                        init();
                    }
                }
            }).trigger('scroll.states');
        },
    },
    projectsSlider: {
        init($slider) {
            new Swiper($slider.find('.swiper-container:visible'), {
                slidesPerView: 1,
                preloadImages: false,
                lazy: true,
                navigation: {
                    prevEl: $slider.find('.projects__slider__prev'),
                    nextEl: $slider.find('.projects__slider__next'),
                },
                pagination: {
                    el: $slider.find('.projects__slider__pager'),
                    type: 'fraction',
                },
            });
        },
    },
    contactsMap: {
        init($map) {
            let options = $map.data();

            app.scriptLoading(`//maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}`, () => {
                let map = new google.maps.Map($map[0], {
                    center: {
                        lat: options.lat,
                        lng: options.lng
                    },
                    zoom: options.zoom,
                    disableDefaultUI: true,
                    scrollwheel: false,
                    zoomControl: true,
                    styles: [
                        {
                            "featureType": "all",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "lightness": -100
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "simplified"
                                },
                                {
                                    "color": "#5b5c64"
                                },
                                {
                                    "lightness": "70"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": -3
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#f1f4f7"
                                },
                                {
                                    "lightness": "60"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "hue": "#ff0000"
                                },
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": -100
                                }
                            ]
                        },
                        {
                            "featureType": "landscape.natural.landcover",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#f1f4f7"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "hue": "#f1f4f7"
                                },
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": -100
                                },
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "hue": "#ff0000"
                                },
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 26
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 100
                                },
                                {
                                    "visibility": "simplified"
                                },
                                {
                                    "color": "#5b5c64"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "lightness": "70"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "hue": "#ff0000"
                                },
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 100
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "simplified"
                                },
                                {
                                    "lightness": "50"
                                },
                                {
                                    "saturation": "100"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "lightness": "100"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": -100
                                }
                            ]
                        }
                    ],
                });

                let infowindow = new google.maps.InfoWindow({
                    content: `<img src="${options.logo}" alt="">`,
                });

                let marker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng(options.lat, options.lng),
                    icon: options.icon
                });

                infowindow.open(map, marker);
            });
        },
    },
    projectsMap: {
        init($projects) {
            let $map = $projects.find('.projects__map__map');

            let options = $map.data();

            let $buttons = $projects.find('.projects__countries__button');

            let defaultMinZoom = 8;

            app.scriptLoading(`//maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}`, () => {
                let map = new google.maps.Map($map[0], {
                    center: {
                        lat: options.lat,
                        lng: options.lng
                    },
                    zoom: options.zoom,
                    disableDefaultUI: true,
                    scrollwheel: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_BOTTOM,
                    },
                    styles: [
                        {
                          "elementType": "labels",
                          "stylers": [
                            {
                              "visibility": "off"
                            }
                          ]
                        },
                        {
                          "featureType": "administrative",
                          "stylers": [
                            {
                              "lightness": -100
                            }
                          ]
                        },
                        {
                          "featureType": "administrative",
                          "elementType": "geometry.fill",
                          "stylers": [
                            {
                              "color": "#fafbfc"
                            }
                          ]
                        },
                        {
                          "featureType": "administrative",
                          "elementType": "labels",
                          "stylers": [
                            {
                              "color": "#5b5c64"
                            },
                            {
                              "lightness": 70
                            },
                            {
                              "visibility": "simplified"
                            }
                          ]
                        },
                        {
                          "featureType": "landscape",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "saturation": -100
                            },
                            {
                              "lightness": -3
                            }
                          ]
                        },
                        {
                          "featureType": "landscape",
                          "elementType": "geometry.fill",
                          "stylers": [
                            {
                              "color": "#f1f4f7"
                            },
                            {
                              "lightness": "60"
                            }
                          ]
                        },
                        {
                          "featureType": "landscape",
                          "elementType": "labels",
                          "stylers": [
                            {
                              "hue": "#ff0000"
                            },
                            {
                              "saturation": -100
                            },
                            {
                              "lightness": -100
                            }
                          ]
                        },
                        {
                          "featureType": "landscape.natural.landcover",
                          "elementType": "geometry.fill",
                          "stylers": [
                            {
                              "color": "#f1f4f7"
                            }
                          ]
                        },
                        {
                          "featureType": "poi",
                          "stylers": [
                            {
                              "hue": "#f1f4f7"
                            },
                            {
                              "saturation": -100
                            },
                            {
                              "lightness": -100
                            },
                            {
                              "visibility": "off"
                            }
                          ]
                        },
                        {
                          "featureType": "road",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "hue": "#ff0000"
                            },
                            {
                              "saturation": -100
                            },
                            {
                              "lightness": 26
                            }
                          ]
                        },
                        {
                          "featureType": "road",
                          "elementType": "labels",
                          "stylers": [
                            {
                              "color": "#5b5c64"
                            },
                            {
                              "saturation": -100
                            },
                            {
                              "lightness": 100
                            },
                            {
                              "visibility": "simplified"
                            }
                          ]
                        },
                        {
                          "featureType": "road",
                          "elementType": "labels.icon",
                          "stylers": [
                            {
                              "visibility": "off"
                            }
                          ]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "geometry.fill",
                          "stylers": [
                            {
                              "lightness": "70"
                            }
                          ]
                        },
                        {
                          "featureType": "road.local",
                          "stylers": [
                            {
                              "hue": "#ff0000"
                            },
                            {
                              "saturation": -100
                            },
                            {
                              "lightness": 100
                            }
                          ]
                        },
                        {
                          "featureType": "transit",
                          "elementType": "labels",
                          "stylers": [
                            {
                              "saturation": "100"
                            },
                            {
                              "lightness": "50"
                            },
                            {
                              "visibility": "simplified"
                            }
                          ]
                        },
                        {
                          "featureType": "water",
                          "elementType": "geometry",
                          "stylers": [
                            {
                              "lightness": "100"
                            },
                            {
                              "visibility": "on"
                            }
                          ]
                        },
                        {
                          "featureType": "water",
                          "elementType": "labels",
                          "stylers": [
                            {
                              "saturation": -100
                            },
                            {
                              "lightness": -100
                            }
                          ]
                        }
                    ],
                });

                let markers = [];

                let osmeCollection = [];

                const setMapOnAll = (map) => {
                    for (let i = 0; i < markers.length; i++) {
                        markers[i].marker.setMap(map);
                    }
                }

                const setMarkers = () => {
                    let $buttonsActive = $buttons.filter('.is-active');

                    let bounds = new google.maps.LatLngBounds();

                    if ($buttonsActive.data('type') === 'all') {
                        $buttonsActive = $buttons;
                    }

                    if ($buttonsActive.data('comm')) {
                        let comm = [];

                        $.each($buttonsActive.data('comm'), (index, item) => {
                            comm.push(`[data-name=${item}]`)
                        });

                        $buttonsActive = $buttons.filter(comm.join(','));
                    }

                    if (markers.length > 0) {
                        setMapOnAll(null);
                        markers = [];
                        osmeCollection.forEach(osmeItem => {
                            osmeItem.remove();
                        });
                        osmeCollection = [];
                    }

                    $buttonsActive.each((index, item) => {
                        let $item = $(item);
                        let itemOptions = $item.data();

                        $.each(itemOptions.items, (index2, item2) => {
                            let labelItems = '';

                            item2.items.forEach(labelItem => {
                                labelItems += `<div class="projects__map__map__label__item"><a href="${labelItem.href}">${labelItem.label}</a></div>`
                            });

                            let infowindow = new google.maps.InfoWindow({
                                content: `<div class="projects__map__map__label">${labelItems}</div>`,
                            });

                            let opened = false;

                            let marker = new google.maps.Marker({
                                map: map,
                                position: new google.maps.LatLng(item2.lat, item2.lng),
                                icon: options.icon
                            });

                            markers.push({
                                marker: marker,
                                label: infowindow,
                                opened: false
                            });

                            marker.addListener('click', function () {
                                if (!opened) {
                                    $.each(markers, (index3, item3) => {
                                        item3.label.close();
                                        item3.marker.setIcon(options.icon);
                                    });
                                    marker.setIcon(options.iconOpen);
                                    infowindow.open(map, marker);
                                    opened = true;
                                } else {
                                    infowindow.close();
                                    marker.setIcon(options.icon);
                                    opened = false;
                                }
                            });

                            // marker.addListener('mouseover', function () {
                            //     marker.setIcon(options.iconOpen);
                            //     infowindow.open(map, marker);
                            // });

                            // marker.addListener('mouseout', function() {
                            //     infowindow.close();
                            //     marker.setIcon(options.icon);
                            // });

                            bounds.extend(new google.maps.LatLng(item2.lat, item2.lng));
                        });

                        if ($item.data('label')) {
                            osme.geoJSON($item.data('label'), {
                                lang: 'ru',
                                quality: +2,
                                type: 'coast',
                            }, function (data) {
                                let collection = osme.toGoogle(data);
                                collection.add(map);
            
                                collection.setStyles(function (object, yobject) {
                                    let level = object.properties.level;
                                    
                                    return ({
                                        strokeWidth: level < 3 ? 0.2 : 0,
                                        strokeColor: '#a0a0a0',
                                        fillColor: '#a0a0a0',
                                        visible: true,
                                        fillOpacity: level < 3 ? 0.3 : 0,
                                    });
                                });

                                osmeCollection.push(collection);
                            });
                        }
                    });

                    if ($buttonsActive.length === 1 && $buttonsActive.data('name') === 'russia') {
                        defaultMinZoom = 4;
                    }

                    if ($buttonsActive.length === 1 && $buttonsActive.data('name') === 'mongolia') {
                        defaultMinZoom = 6;
                    }

                    map.fitBounds(bounds);

                    if (map.getZoom() > defaultMinZoom) {
                        map.setZoom(defaultMinZoom)
                    }
                }

                setMarkers();

                $buttons.on('click', (e) => {
                    e.preventDefault();
                    $buttons.removeClass('is-active');
                    $(e.currentTarget).addClass('is-active');
                    setMarkers();
                });
            });
        },
    },
    scriptLoading(src, callback) {
        let script = document.createElement('script');

        let loaded;

        script.setAttribute('src', src);
        if (callback) {
            script.onreadystatechange = script.onload = () => {
                if (!loaded) {
                    callback();
                }
                loaded = true;
            };
        }
        document.getElementsByTagName('head')[0].appendChild(script);
    },
    develops: {
        init($develops) {
            function _instanceof(left, right) {
                if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
                    return !!right[Symbol.hasInstance](left);
                } else {
                    return left instanceof right;
                }
            }

            function _classCallCheck(instance, Constructor) {
                if (!_instanceof(instance, Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }

            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }

            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }

            var canvas,
                ctx,
                lines = [],
                timeout,
                isMoving = false,
                mouse = {
                    'x': 0,
                    'y': 0
                },
                windowWidth = $(window).width(),
                windowHeight = $(window).height();
            var canvasWidth = windowWidth >= 1328 ? 1328 : windowWidth;
            var PARAMS = {
                'debug': false,
                'canvasWidth': canvasWidth,
                'canvasHeight': 225,
                'dotRadius': 1,
                'xFieldOffset': 0,
                'yFieldOffset': 0,
                'xStepCoefficient': 20,
                'yStepCoefficient': 40,
                'step': 10,
                'rowsCount': 6,
                'columnsCount': 45,
                'length': 18,
                'anchorY': 350,
                'corner': 17.5
            };

            var Line =
                /*#__PURE__*/
                function () {
                    function Line(params) {
                        _classCallCheck(this, Line);

                        this.p1 = {
                            'x': params.p1.x,
                            'y': params.p1.y
                        };
                        this.p2 = {
                            'x': params.p2.x,
                            'y': params.p2.y
                        };
                        this.color = params.color;
                        this.opacity = params.opacity;
                    }

                    _createClass(Line, [{
                        key: "draw",
                        value: function draw() {
                            this.distance = Math.sqrt(Math.pow(this.p1.x - this.p2.x, 2) + Math.pow(this.p1.y - this.p2.y, 2));
                            this.pointsCount = Math.round(this.distance / PARAMS.dotRadius / 4);
                            this.deltaX = (this.p2.x - this.p1.x) / (this.pointsCount - 1);
                            this.deltaY = (this.p2.y - this.p1.y) / (this.pointsCount - 1);
                            ctx.beginPath();
                            ctx.fillStyle = this.color;
                            ctx.globalAlpha = this.opacity;

                            for (var i = 0; i < this.pointsCount; i++) {
                                var x = this.p1.x + this.deltaX * i,
                                    y = this.p1.y + this.deltaY * i;
                                ctx.arc(x, y, PARAMS.dotRadius, 0, Math.PI + Math.PI * 2 / 2, true);
                            }

                            ctx.fill();
                            ctx.globalAlpha = 1;
                        }
                    }, {
                        key: "updateState",
                        value: function updateState() {
                            var dx = mouse.x - windowWidth / 2;
                            var dy = mouse.y - PARAMS.canvasHeight + PARAMS.anchorY;
                            var d = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                            var p = PARAMS.length / d;

                            if (Math.abs(dx * p) > PARAMS.corner) {
                            } else {
                                this.p2.x = this.p1.x + dx * p;
                                this.p2.y = this.p1.y - Math.abs(dy * p);
                            }
                        }
                    }]);

                    return Line;
                }();

            $(document).ready(function () {

                start();
                generateLines();
                $(document).on('mousemove', function (event) {
                    clearInterval(timeout);
                    isMoving = true;
                    mouse.x = event.clientX;
                    mouse.y = event.clientY;
                    timeout = setTimeout(function () {
                        isMoving = false;
                    }, 500);
                });
                requestAnimationFrame(update);
            });

            function start() {
                canvas = document.getElementById("lines");
                ctx = canvas.getContext("2d");
                canvas.width = PARAMS.canvasWidth;
                canvas.height = PARAMS.canvasHeight;

                if (PARAMS.debug === false) {
                }
            }

            function generateLines() {
                var x1, y1, x2, y2;

                for (var i = 0; i < PARAMS.rowsCount; i++) {
                    for (var j = 0; j < PARAMS.columnsCount; j++) {
                        if (j % 2 === 0) {
                            x1 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                            y1 = i * PARAMS.yStepCoefficient + PARAMS.yFieldOffset;
                            x2 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                            y2 = i * PARAMS.yStepCoefficient + PARAMS.length + PARAMS.yFieldOffset;
                        } else {
                            x1 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                            y1 = i * PARAMS.yStepCoefficient + PARAMS.step + PARAMS.yFieldOffset;
                            x2 = j * PARAMS.xStepCoefficient + j * PARAMS.step + PARAMS.xFieldOffset;
                            y2 = i * PARAMS.yStepCoefficient + PARAMS.length + PARAMS.step + PARAMS.yFieldOffset;
                        }

                        var params = {};
                        params.p1 = {
                            'x': x1,
                            'y': y1
                        };
                        params.p2 = {
                            'x': x2,
                            'y': y2
                        };
                        params.color = '#FFFFFF';
                        params.opacity = 0.2;
                        var line = new Line(params);
                        line.draw();
                        lines.push(line);
                    }
                }
            }

            function update() {
                if (isMoving) {
                    drawAll();
                }

                requestAnimationFrame(update);
            }

            function drawAll() {
                ctx.clearRect(0, 0, windowWidth, windowHeight);

                for (var k = 0; k < lines.length; k++) {
                    lines[k].updateState();
                    lines[k].draw();
                }
            }
        },
    },
    debentures: {
        init($debentures) {
            $debentures.find('.detailsnews__doc').on('click', (e) => {
                let file = $debentures.find('.debentures__block__files');

                e.preventDefault();
                $debentures.find('.detailsnews__doc').toggleClass('is-active-doc');
                file.toggleClass('is-active-doc');
                $debentures.find('.detailsnews__calendar').removeClass('is-active-calendar')
                $debentures.find('.debentures__block__calendar').removeClass('is-active-calendar');
            });

            $debentures.find('.detailsnews__calendar').on('click', (e) => {
                let file = $debentures.find('.debentures__block__calendar');

                e.preventDefault();
                $debentures.find('.detailsnews__calendar').toggleClass('is-active-calendar');
                file.toggleClass('is-active-calendar');
                $debentures.find('.detailsnews__doc').removeClass('is-active-doc')
                $debentures.find('.debentures__block__files').removeClass('is-active-doc');
            });

            $debentures.find('.js-debentures-series-row').on('click', (e) => {
                let $calendarItem = $debentures.find('.js-debentures-calendar-item');

                e.preventDefault();
                $debentures.find('.js-debentures-series-row').removeClass('is-active');
                $(e.currentTarget).addClass('is-active');
                $calendarItem.addClass('is-hidden');
                $calendarItem.filter(`[data-item="${$(e.currentTarget).data('item')}"]`).removeClass('is-hidden');
            });
        },
    },
    navToggle: {
        init($button) {
            let $nav = $button.closest('.mission__side').find('.mission__nav');

            $button.on('click', (e) => {
                e.preventDefault();
                $button.toggleClass('is-active');
                if ($button.hasClass('is-active')) {
                    $nav.stop().slideDown(250);
                } else {
                    $nav.stop().slideUp(250);
                }
            });
        },
    },
    linkMore: {
        init($link) {
            $link.on('click', (e) => {
                e.preventDefault();
                $link.toggleClass('is-active');
                if ($link.hasClass('is-active')) {
                    $($link.data('target')).removeClass('is-hidden');
                    $link.find('.link-more__text').text($link.data('on'));
                } else {
                    $($link.data('target')).addClass('is-hidden');
                    $link.find('.link-more__text').text($link.data('off'));
                }
                $('.mission__nav').trigger("sticky_kit:recalc");
            });
        },
    },
    toTop: {
        init($button) {
            $button.on('click', (e) => {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            });

            $window.on('scroll', () => {
                if ($window.scrollTop() > 300) {
                    $button.addClass('is-show');
                } else {
                    $button.removeClass('is-show');
                }
            }).trigger('scroll');
        },
    },
    videos: {
        init($videos) {
            $videos.on('click', '.videos__block__right .videos__item', (e) => {
                let $this = $(e.currentTarget);

                let $thumbs = $videos.find('.videos__block__right .videos__item');

                let $items = $videos.find('.videos__block__left .videos__item');

                e.preventDefault();
                $thumbs.removeClass('is-active');
                $this.addClass('is-active');
                $items.removeClass('is-active');
                $items.filter(`[data-item="${$this.data('item')}"]`).addClass('is-active');
            });
        },
    },
    generalHistory: {
        init($history) {
            let $years = $history.find('.general__history__years a');

            let $items = $history.find('.general__history__item');

            $years.on('click', (e) => {
                let $this = $(e.currentTarget);

                e.preventDefault();
                $years.removeClass('is-active');
                $items.removeClass('is-active');
                $this.addClass('is-active');
                $items.filter(`[data-item="${$this.data('target')}"]`).addClass('is-active');
            });

            $history.find('.general__history__prev').on('click', (e) => {
                let $active = $years.filter('.is-active');

                let $next = $active.closest('li').next('li').length ? $active.closest('li').next('li').find('a') : $history.find('.general__history__years li:first-child a');

                e.preventDefault();
                $next.trigger('click');
            });

            $history.find('.general__history__next').on('click', (e) => {
                let $active = $years.filter('.is-active');

                let $next = $active.closest('li').prev('li').length ? $active.closest('li').prev('li').find('a') : $history.find('.general__history__years li:last-child a');

                e.preventDefault();
                $next.trigger('click');
            });
        },
    },
    cooperationDirections: {
        init($directions) {
            let $items = $directions.find('.intro__text');

            let $links = $directions.find('.cooperation__item');

            $links.on('click', (e) => {
                e.preventDefault();

                $items.addClass('is-hidden');
                $items.filter(`[data-item="${$(e.currentTarget).data('item')}"]`).removeClass('is-hidden');
            });

            $links.hover(
                (e) => {
                    e.preventDefault();

                    $items.addClass('is-hidden');
                    $items.filter(`[data-item="${$(e.currentTarget).data('item')}"]`).removeClass('is-hidden');
                },
                () => {
                }
            );
        },
    },
    newsFilter: {
        init($filter) {
            let $container = $(`[data-container="${$filter.data('target')}"]`);
            let getDataTimeout;
            const getData = () => {
                clearTimeout(getDataTimeout);
                getDataTimeout = setTimeout(() => {
                    $.ajax({
                        type: $filter.attr('method'),
                        url: $filter.attr('action'),
                        data: $filter.serialize(),
                        success(response) {
                            $container.html(response);
                        },
                    });
                }, 250);
            }

            $filter.on('change', () => {
                getData();
            });

            $filter.find('.js-news-filter-reset').on('click', (e) => {
                e.preventDefault();
                $filter[0].reset();
                $filter.find('.input select').val('').trigger('change');
            });
        },
    },
    schedule: {
        init($schedule) {
            const scheduleSwitch = $schedule.find('.is-schedule__switch-input'),
                scheduleMonth = $schedule.find('.is-schedule__month'),
                scheduleYear = $schedule.find('.is-schedule__year');
            const switchCheck = function(){
                if (scheduleSwitch.is(':checked')){
                    scheduleYear.show();
                    scheduleMonth.hide();
                } else {
                    scheduleYear.hide();
                    scheduleMonth.show();
                }
            }
            switchCheck();
            scheduleSwitch.on('change', function(){
                switchCheck();
            });
            if (!vars.isMobile()) {
                tippy('[data-tippy-content]', {
                    theme: 'custom',
                    placement: 'top-start',
                    followCursor: true,
                    arrow: false,
                    offset: [16, -13],
                    maxWidth: 350
                });                
            } else {
                tippy('[data-tippy-content]', {
                    theme: 'custom',
                    placement: 'top-start',
                    arrow: false,
                    offset: [16, -16],
                    maxWidth: 300,
                    trigger: 'click'
                });    
            }

        }
    }
};

app.global.init();

let initApps = () => {
    $('[data-app]').each((index, item) => {
        let $this = $(item);

        let split = $this.data('app').split('||');

        $.each(split, (appIndex, appName) => {
            let appNameCamel = false;

            if (appName.indexOf('-') !== -1) {
                appNameCamel = appName.replace(/(-|\s)(\S)/ug, (m) => m.toUpperCase()).replace(/-/ug, '');
            }

            if (app[appName] && $this.data(`${appName}-init`) !== true) {
                app[appName].init($this);
                $this.data(`${appName}-init`, true);
            } else if (app[appNameCamel] && $this.data(`${appName}-init`) !== true) {
                app[appNameCamel].init($this);
                $this.data(`${appName}-init`, true);
            }
        });
    });
};

initApps();
